import { useEffect, useRef } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useStore } from '@nx/app-store'
import { createUserState } from '@nx/bidding-engine'

import { useGetUser } from '@web/helpers/api'
import { useGetActiveBids } from '@web/helpers/api/user/getUserBids/getUserBids'
import { useGetUsersWonLots } from '@web/helpers/api/user/getUsersWonLots/getUsersWonLots'
import { useGetUserInvoices } from '@web/helpers/api/user/useGetUserInvoices/useGetUserInvoices'

export function usePopulateStore() {
  const storePopulated = useRef(false)

  const userLots = useStore(useShallow((store) => store.user.lots))
  const storeActions = useStore(
    useShallow((store) => ({
      createLots: store.createLots,
      clearLots: store.clearLots,
    }))
  )
  const { data: user } = useGetUser()
  const { data: userActiveBids, isSuccess: userActiveBidsSuccess } =
    useGetActiveBids()
  const { data: userInvoices, isSuccess: userInvoicesSuccess } =
    useGetUserInvoices({
      userId: user?.customerId || 0,
      paymentStatus: 'UNPAID',
    })
  const { data: userWonLots, isSuccess: userWonLotsSuccess } =
    useGetUsersWonLots()

  useEffect(() => {
    const lotDataExists = !!Object.keys(userLots).length

    if (!!user && !storePopulated.current) {
      if (!userActiveBidsSuccess || !userInvoicesSuccess || !userWonLotsSuccess)
        return

      if (!lotDataExists) {
        const state = createUserState({
          activeBids: userActiveBids.bids,
          invoices: userInvoices.hits,
          wonLots: userWonLots,
        })

        storeActions.createLots(state.user.lots)
      }

      storePopulated.current = true
    } else if (!user && storePopulated.current) {
      if (lotDataExists) {
        storeActions.clearLots()
      }

      storePopulated.current = false
    }
  }, [
    user,
    storeActions,
    userLots,
    userActiveBids,
    userInvoices,
    userWonLots,
    storePopulated,
    userActiveBidsSuccess,
    userInvoicesSuccess,
    userWonLotsSuccess,
  ])
}
